import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
const style = () =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      textAlign: 'center',
      gap: '10px',
      fontWeight: 500,
      fontSize: '12px',
      color: palette.text.white,
      background: palette.background.autumn,
      padding: '5px',
      borderRadius: palette.borderRadius.default
    },
    descTags: {
      display: 'flex',
      gap: '10px',
      width: '90px'
    },
    descTag: {
      display: 'flex',
      gap: '10px',
      width: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
